import React from 'react';
import './terms.css'; // Reuse or create a new 'faq.css' for styling
import GameHeader from '../header/header';

const FAQs = () => {
    return (
        <div className="obtibg">
                <GameHeader />
                <div className="terms-container">
                    <div className="terms-content">
                        <h1>Frequently Asked Questions (FAQs)</h1>

                        <h2>General Information</h2>
                        <p>
                            <strong>1. Can I register multiple accounts?</strong><br />
                            No. Each member is allowed only one account. Multiple accounts or using the same wallet address across accounts is strictly prohibited. Detected violations will lead to account suspension. Please contact customer service if you believe there's been an error.
                        </p>

                        <p>
                            <strong>2. What happens if suspicious activity is detected?</strong><br />
                            Any form of malicious behavior, including money laundering or abuse of the platform's features, will result in immediate account freezing and possible legal action.
                        </p>

                        <h2>Deposits</h2>
                        <p>
                            <strong>1. How do I make a deposit?</strong><br />
                            Contact our customer service to begin the deposit process. After receiving a verified account, transfer your funds and share a screenshot of the successful transaction. Always confirm the account details before sending funds, as they may change.
                        </p>

                        <p>
                            <strong>2. What should I do if there’s an issue with my deposit?</strong><br />
                            If you face any problems during the process, please reach out to our deposit support team via live chat immediately.
                        </p>

                        <h2>Withdrawals</h2>
                        <p>
                            <strong>1. How can I withdraw my funds?</strong><br />
                            Ensure your withdrawal wallet is bound to your account. Navigate to the "Withdrawal" section on the home page, enter your withdrawal amount and password, then submit. Withdrawals are processed within one hour during platform operating hours.
                        </p>

                        <h2>Exposure</h2>
                        <p>
                            <strong>1. What is exposure game and why is my balance negative?</strong><br />
                            A negative balance indicates that a exposure game Bundle (1–3 applications) has been assigned to your account. This allocation depends on your account status. Complete the software to earn triple commissions. For payment help, please contact support.
                        </p>

                        <h2>Referral & Commissions</h2>
                        <p>
                            <strong>1. How does the agent referral system work?</strong><br />
                            By referring new users, you can earn dynamic commissions. The system automatically rewards you with 20% of your downline’s earnings.
                        </p>

                        <h2>Platform Hours</h2>
                        <p>
                            <strong>1. When is the platform operational?</strong><br />
                            Epic Games operates daily from 12:00 PM to 12:00 AM. All optimization and service-related activities are processed during these hours.
                        </p>

                        <p className="closing">
                            For any other questions or support needs, please contact our live customer service. Thank you for being a part of Epic Games.
                        </p>

                        <footer className="faq-footer mt-5">
                            <hr />
                            <small>
                                © 2025 Epic Games. All rights reserved. | <a href="/">Legal Terms</a> | <a href="/">Privacy Policy</a> | <a href="/">Cookie Settings</a>
                            </small>
                            <br />
                            <small>United States</small>
                        </footer>
                    </div>
                </div>
        </div>
    );
};

export default FAQs;
